

import { useEffect, useState } from "react";
import { useToast } from "@/context/ToastContext";

export function ServiceWorkerRegister() {
  const { showToast } = useToast();
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          console.log("Service Worker registered:", registration.scope);

          // Check for updates
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener("statechange", () => {
                if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                  // New update available
                  setUpdateAvailable(true);
                  showToast("App update available! Refresh to update.", "info");
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });

      // Listen for messages from service worker
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data === "update-available") {
          setUpdateAvailable(true);
          showToast("App update available! Refresh to update.", "info");
        }
      });
    }
  }, [showToast]);

  // Handle update button click
  const handleUpdate = () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.waiting?.postMessage("skipWaiting");
        window.location.reload();
      });
    }
  };

  return updateAvailable ? (
    <div className="fixed bottom-4 right-4 z-50 bg-amber-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3">
      <span className="text-sm font-medium">Update available</span>
      <button
        onClick={handleUpdate}
        className="px-3 py-1.5 bg-white text-amber-600 text-sm font-semibold rounded-md hover:bg-amber-50 transition-colors"
      >
        Update Now
      </button>
    </div>
  ) : null;
}
